export default __webpack_public_path__ + "static/img7-6a2ae533538938b6ff49fc3a5ead3448.png";